

























import {Component, Emit, Prop, PropSync, Vue} from 'vue-property-decorator'
import {datePickerOptions} from "@/component/DatePicker";

@Component({})
export default class SingleDayColumn extends Vue {
  private pickerOptions = datePickerOptions

  @Prop()
  label!: string

  @PropSync('start')
  startSync?: Date

  @Emit()
  change() {
    //
  }
}
